import { render, staticRenderFns } from "./AfipTiposPage.vue?vue&type=template&id=05c4de89&scoped=true"
import script from "./AfipTiposPage.vue?vue&type=script&lang=js"
export * from "./AfipTiposPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c4de89",
  null
  
)

export default component.exports